(function ($, Drupal, drupalSettings, once) {
  'use strict';

  var activeIcon;

  /* INSTATIATE OBJECT FIT FOR PATHWAYS IMAGE */
  objectFitImages('.trail-location-item__image', {watchMQ: true}); // eslint-disable-line no-undef

  // Disable for usage of polyfill.
  /* eslint-disable */
  (function templatePolyfill(d) {
    if ('content' in d.createElement('template')) {
      return false;
    }

    var qPlates = d.getElementsByTagName('template');
    var plateLen = qPlates.length;
    var elPlate;
    var qContent;
    var contentLen;
    var docContent;

    for (var x = 0; x < plateLen; ++x) {
      elPlate = qPlates[x];
      qContent = elPlate.childNodes;
      contentLen = qContent.length;
      docContent = d.createDocumentFragment();

      while (qContent[0]) {
        docContent.appendChild(qContent[0]);
      }

      elPlate.content = docContent;
    }
  })(document);
  /* eslint-enable */

  $.urlParam = function (name) {
    var results = new RegExp('[?&]' + name + '=([^&#]*)').exec(window.location.href);
    if (results !== null) {
      results[1] = results[1].replace('+', ' ');
      return results[1] ? decodeURIComponent(results[1]) : null;
    }
    return null;
  };

  /**
   * Gets a deeply nested value in an object. Returns default value if unset.
   *
   * @function
   * @param {object} obj
   *   The object which contains the value you want to change/set.
   * @param {array} parents
   *   The array representation of path to the value you want to change/set.
   * @param {*} defaultValue
   *   The default value to return if the nested object property is unset.
   *
   * @return {*}
   *   The nested object property if set. The defaultValue otherwise.
   */
  function getNestedValue(obj, parents, defaultValue) {
    var length = parents.length;

    for (var i = 0; i < length; i++) {
      if (!obj || typeof obj !== 'object' || typeof obj[parents[i]] === 'undefined' || obj[parents[i]] === null) {
        return defaultValue;
      }
      obj = obj[parents[i]];
    }

    return obj;
  }

  /**
   * Dynamically sets a deeply nested value in an object.
   *
   * @function
   * @param {object} obj
   *   The object which contains the value you want to change/set.
   * @param {array} parents
   *   The array representation of path to the value you want to change/set.
   * @param {*} value
   *   The value you want to set it to.
   */
  function setNestedValue(obj, parents, value) {
    var level = 0;
    parents.reduce(function (a, b) {
      level++;
      if (typeof a[b] === 'undefined' && level !== parents.length) {
        a[b] = {};
        return a[b];
      }

      if (level === parents.length) {
        a[b] = value;
        return value;
      }
      else {
        return a[b];
      }

    }, obj);
  }

  /**
   * Calculates the distance in km from one geolocation to another.
   *
   * @param {number} lat1
   *   Latitude of point 1.
   * @param {number} lon1
   *   Longitude of point 1.
   * @param {number} lat2
   *   Latitude of point 2.
   * @param {number} lon2
   *   Longitude of point 2.
   *
   * @return {number}
   *   The distance in km.
   */
  function calculateDistance(lat1, lon1, lat2, lon2) {
    var R = 6371; // km
    var dLat = toRad(lat2 - lat1);
    var dLon = toRad(lon2 - lon1);
    lat1 = toRad(lat1);
    lat2 = toRad(lat2);

    var a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.sin(dLon / 2) * Math.sin(dLon / 2) * Math.cos(lat1) * Math.cos(lat2);
    var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    var d = R * c;

    return d;
  }

  /**
   * Converts a number to a radian value.
   *
   * @param {number} Value
   *   The number.
   *
   * @return {number}
   *   The radian version of the value.
   */
  function toRad(Value) {
    return Value * Math.PI / 180;
  }

  Drupal.behaviors.componentTrailMap = {

    trails: {},
    trailGeolocations: {
      directions: {
        bristol: {lat: 36.5319241, lng: -82.3494935},
        chattanooga: {lat: 35.0982754, lng: -85.3087306},
        knoxville: {lat: 35.9584416, lng: -83.9951221},
        memphis: {lat: 35.1291054, lng: -90.1108699},
        nashville: {lat: 36.1865589, lng: -86.9253283},
        smokies: {lat: 35.727245, lng: -83.5330358},

        // Deprecated
        middle: {lat: 35.842732, lng: -86.406735},
        nw: {lat: 36.462962, lng: -89.451788},
        n: {lat: 36.621240, lng: -85.767652},
        ne: {lat: 36.586377, lng: -81.708587},
        e: {lat: 35.786185, lng: -82.998432},
        se: {lat: 35.023884, lng: -84.358282},
        s: {lat: 35.020952, lng: -87.187839},
        sw: {lat: 34.996085, lng: -90.309005},
        w: {lat: 35.726370, lng: -89.923687}
      }
    },
    trailLocations: {},
    trailLocationsLatLng: [],
    trailMapMarkerClusters: {},
    trailMapMarkerSpiderfier: {},
    trailMapMarkers: {},
    trailMaps: {},
    trailMapSettings: {},
    overviewMapSettings: {},
    // trailMapStyles: JSON.parse(drupalSettings.tnv_google_maps.settings.style),
    /* eslint-disable */
    trailMapStyles: [{"elementType":"geometry","stylers":[{"color":"#ebe3cd"}]},{"elementType":"labels.icon","stylers":[{"visibility":"off"}]},{"elementType":"labels.text.fill","stylers":[{"color":"#523735"}]},{"elementType":"labels.text.stroke","stylers":[{"color":"#f5f1e6"}]},{"featureType":"administrative","elementType":"geometry.stroke","stylers":[{"color":"#000000"},{"weight":2}]},{"featureType":"administrative.land_parcel","stylers":[{"visibility":"off"}]},{"featureType":"administrative.land_parcel","elementType":"geometry.stroke","stylers":[{"color":"#dcd2be"}]},{"featureType":"administrative.land_parcel","elementType":"labels.text.fill","stylers":[{"color":"#bdbdbd"}]},{"featureType":"administrative.province","elementType":"geometry.stroke","stylers":[{"visibility":"on"},{"weight":1.5}]},{"featureType":"landscape.natural","elementType":"geometry","stylers":[{"color":"#dfd2ae"}]},{"featureType":"poi","elementType":"geometry","stylers":[{"color":"#dfd2ae"}]},{"featureType":"poi","elementType":"labels.icon","stylers":[{"visibility":"simplified"}]},{"featureType":"poi","elementType":"labels.text","stylers":[{"visibility":"off"}]},{"featureType":"poi","elementType":"labels.text.fill","stylers":[{"color":"#93817c"}]},{"featureType":"poi.park","stylers":[{"visibility":"off"}]},{"featureType":"poi.park","elementType":"geometry","stylers":[{"color":"#e5e5e5"}]},{"featureType":"poi.park","elementType":"geometry.fill","stylers":[{"color":"#a5b076"},{"visibility":"on"}]},{"featureType":"poi.park","elementType":"labels.text.fill","stylers":[{"color":"#447530"}]},{"featureType":"road","elementType":"geometry","stylers":[{"color":"#f5f1e6"}]},{"featureType":"road.arterial","elementType":"geometry","stylers":[{"color":"#fdfcf8"}]},{"featureType":"road.arterial","elementType":"labels.text.fill","stylers":[{"color":"#757575"}]},{"featureType":"road.highway","elementType":"geometry","stylers":[{"color":"#f8c967"}]},{"featureType":"road.highway","elementType":"geometry.stroke","stylers":[{"color":"#e9bc62"}]},{"featureType":"road.highway","elementType":"labels","stylers":[{"visibility":"simplified"}]},{"featureType":"road.highway","elementType":"labels.text.fill","stylers":[{"color":"#616161"}]},{"featureType":"road.highway.controlled_access","elementType":"geometry","stylers":[{"color":"#e98d58"}]},{"featureType":"road.highway.controlled_access","elementType":"geometry.stroke","stylers":[{"color":"#db8555"}]},{"featureType":"road.local","elementType":"labels.text.fill","stylers":[{"color":"#806b63"}]},{"featureType":"transit.line","elementType":"geometry","stylers":[{"color":"#dfd2ae"}]},{"featureType":"transit.line","elementType":"labels.text.fill","stylers":[{"color":"#8f7d77"}]},{"featureType":"transit.line","elementType":"labels.text.stroke","stylers":[{"color":"#ebe3cd"}]},{"featureType":"transit.station","elementType":"geometry","stylers":[{"color":"#dfd2ae"}]},{"featureType":"water","elementType":"geometry","stylers":[{"color":"#c9c9c9"}]},{"featureType":"water","elementType":"geometry.fill","stylers":[{"color":"#b9d3c2"}]},{"featureType":"water","elementType":"labels.text.fill","stylers":[{"color":"#92998d"}]}],
    /* eslint-enable */
    trailMapTimeout: {},

    attach: function (context, settings) {
      if (/MSIE \d|Trident.*rv:/.test(navigator.userAgent)) {
        document.createElement('template');
      }

      // Set main default trail dropdown.
      Drupal.behaviors.componentTrailMap.updateMainTrailFilter();
      // Run through each trail on the page.
      $('.component-trail.node--type-trail.node--view-mode-full:not(.component-trail--initialized)').each(function () {
        // Add toggle.
        Drupal.behaviors.componentTrailMap.createToggle();

        // Get relevant script paths.
        var pathApiTrails = '/api/1/trail/all?_format=json';
        var pathApiTrailLocations = '/api/1/trail/' + $(this).data('trail-id') + '/locations?_format=json';

        // Retrieve relevant data for each trail.
        $.when($(this), $.ajax(pathApiTrails), $.ajax(pathApiTrailLocations)).done(function (trailElement, trailAjaxData, trailAjaxLocationData) {
          // If the ajax data was successfully returned, build the map.
          if (trailAjaxData[1] === 'success' && trailAjaxLocationData[1] === 'success' && trailAjaxData[2].status === 200 && trailAjaxLocationData[2].status === 200) {
            $('.component-trail__trail-aside-total-stops').prepend('<span class="total-stops">' + trailAjaxLocationData[0].count + '</span>');
            Drupal.behaviors.componentTrailMap.buildComponent(trailElement, trailAjaxData[0].results, trailAjaxLocationData[0].results);
            drupalSettings.trailLocations = trailAjaxLocationData[0].results;
            $('.component-trail__overview-map').show();
          }
        });

        // Track that this trail was initialized.
        $(this).addClass('component-trail--initialized');

      });

      // On page resize, check if a trail detail should have items hidden.
      $(window).resize(function () {
        $('.trail-location-detail-featured-on__list').each(function (index, element) {
          $(this).parents('.trail-location-detail-featured-on').toggleClass('trail-location-detail-featured-on--has-more-available', ($(this).height() > 200));
        });
      });

      // Initialize each trail callout on page load by calling window resize.
      $(window).resize();
    },

    /**
     * Build a trail component based on trail and trail location data.
     *
     * @param {jQuery} $trailElement
     *   The Trail jQuery element.
     * @param {array} trails
     *   A list of all available trails.
     * @param {array} trailLocations
     *   A list of locations on the current trail.
     */
    buildComponent: function ($trailElement, trails, trailLocations) {
      // Get the trail ID.
      var trailId = $trailElement.data('trail-id');

      // Track this component instance.
      var instanceId = Math.random().toString(36).substr(2, 9);
      $trailElement.attr('data-instance-id', instanceId);

      // Initialize the Map.
      var map = new google.maps.Map($trailElement.find('.component-trail__map')[0], {
        center: {lat: 35.860119, lng: -86.660156},
        mapTypeControl: false,
        maxZoom: 19,
        styles: Drupal.behaviors.componentTrailMap.trailMapStyles,
        zoom: 8
      });

      var overviewMap = new google.maps.Map($trailElement.find('.component-trail__overview-map')[0], {
        center: {lat: 35.860119, lng: -86.660156},
        clickableIcons: false,
        mapTypeControl: false,
        zoomControl: false,
        draggable: false,
        fullscreenControl: false,
        keyboardShortcuts: false,
        /* eslint-disable */
        styles: [{"elementType":"geometry","stylers":[{"color":"#f5f5f5"}]},{"elementType":"labels.icon","stylers":[{"visibility":"off"}]},{"elementType":"labels.text.fill","stylers":[{"color":"#616161"}]},{"elementType":"labels.text.stroke","stylers":[{"color":"#f5f5f5"}]},{"featureType":"administrative.land_parcel","stylers":[{"visibility":"off"}]},{"featureType":"administrative.land_parcel","elementType":"labels.text.fill","stylers":[{"color":"#bdbdbd"}]},{"featureType":"administrative.province","elementType":"geometry.stroke","stylers":[{"color":"#000000"},{"visibility":"on"},{"weight":1.5}]},{"featureType":"poi","stylers":[{"visibility":"off"}]},{"featureType":"poi","elementType":"geometry","stylers":[{"color":"#eeeeee"}]},{"featureType":"poi","elementType":"labels.text.fill","stylers":[{"color":"#757575"}]},{"featureType":"poi.park","stylers":[{"visibility":"simplified"}]},{"featureType":"poi.park","elementType":"geometry","stylers":[{"color":"#e5e5e5"}]},{"featureType":"poi.park","elementType":"labels.text.fill","stylers":[{"color":"#9e9e9e"}]},{"featureType":"road","elementType":"geometry","stylers":[{"color":"#ffffff"}]},{"featureType":"road.arterial","elementType":"labels.text.fill","stylers":[{"color":"#757575"}]},{"featureType":"road.highway","elementType":"geometry","stylers":[{"color":"#dadada"}]},{"featureType":"road.highway","elementType":"labels.text.fill","stylers":[{"color":"#616161"}]},{"featureType":"road.local","elementType":"labels.text.fill","stylers":[{"color":"#9e9e9e"}]},{"featureType":"transit.line","elementType":"geometry","stylers":[{"color":"#e5e5e5"}]},{"featureType":"transit.station","elementType":"geometry","stylers":[{"color":"#eeeeee"}]},{"featureType":"water","elementType":"geometry","stylers":[{"color":"#c9c9c9"}]},{"featureType":"water","elementType":"labels.text.fill","stylers":[{"color":"#9e9e9e"}]}],
        /* eslint-enable */
        maxZoom: 19,
        zoom: 5.25
      });

      var overviewRectangle;

      google.maps.event.addListener(map, 'idle', function () {
        // Determine map center.
        var overviewMapBounds = map.getBounds().toJSON();
        setNestedValue(Drupal.behaviors.componentTrailMap.overviewMapSettings, [instanceId, 'bounds'], overviewMapBounds);

        if (typeof overviewRectangle !== 'undefined') {
          removeRectangle();
        }

        // Determine map bounds.
        overviewMapBounds = getNestedValue(Drupal.behaviors.componentTrailMap.overviewMapSettings, [instanceId, 'bounds'], null);
        var rectangleBounds = {
          north: overviewMapBounds.north,
          south: overviewMapBounds.south,
          east: overviewMapBounds.east,
          west: overviewMapBounds.west
        };

        // Define a rectangle and set its editable property to true.
        overviewRectangle = new google.maps.Rectangle({
          bounds: rectangleBounds,
          editable: false,
          strokeColor: '#AB1212',
          strokeOpacity: 0.3,
          strokeWeight: 1,
          fillColor: '#AB1212',
          fillOpacity: 0.1
        });
        overviewRectangle.setMap(overviewMap);
      });

      google.maps.event.addListener(map, 'dragend', function () {
        if (typeof overviewRectangle !== 'undefined') {
          removeRectangle();
        }

        // Determine map bounds.
        var overviewMapBounds = getNestedValue(Drupal.behaviors.componentTrailMap.overviewMapSettings, [instanceId, 'bounds'], null);
        var rectangleBounds = {
          north: overviewMapBounds.north,
          south: overviewMapBounds.south,
          east: overviewMapBounds.east,
          west: overviewMapBounds.west
        };

        // Define a rectangle and set its editable property to true.
        overviewRectangle = new google.maps.Rectangle({
          bounds: rectangleBounds,
          editable: false,
          strokeColor: '#AB1212',
          strokeOpacity: 0.3,
          strokeWeight: 1,
          fillColor: '#AB1212',
          fillOpacity: 0.1
        });
        overviewRectangle.setMap(overviewMap);
      });

      google.maps.event.addListener(map, 'zoom_changed', function () {
        if (typeof overviewRectangle !== 'undefined') {
          removeRectangle();
        }

        // Determine map bounds.
        var overviewMapBounds = getNestedValue(Drupal.behaviors.componentTrailMap.overviewMapSettings, [instanceId, 'bounds'], null);

        if (overviewMapBounds === null) {
          return;
        }

        var rectangleBounds = {
          north: overviewMapBounds.north,
          south: overviewMapBounds.south,
          east: overviewMapBounds.east,
          west: overviewMapBounds.west
        };

        // Define a rectangle and set its editable property to true.
        overviewRectangle = new google.maps.Rectangle({
          bounds: rectangleBounds,
          editable: false,
          strokeColor: '#AB1212',
          strokeOpacity: 0.3,
          strokeWeight: 1,
          fillColor: '#AB1212',
          fillOpacity: 0.1
        });
        overviewRectangle.setMap(overviewMap);
      });

      function removeRectangle() {
        overviewRectangle.setMap(null);
      }

      google.maps.event.addListenerOnce(map, 'idle', function () {
        if ($.urlParam('selected-region') !== null) {
          var selectedRegion = $('[data-filter-controller~="location"] a.pselect-item[data-filter-value="' + $.urlParam('selected-region') + '"]');
          Drupal.behaviors.componentTrailMap.autoInitDirectionFilter(selectedRegion);
        }
        if ($.urlParam('selected-city') !== null) {
          var selectedCity = $.urlParam('selected-city');
          Drupal.behaviors.componentTrailMap.autoInitDirectionFilter(selectedCity);
        }
        // The loader icon is shown by default, then hid when all the map tiles
        // are loaded.
        $('.form__loader').hide();
      });

      // Disabling eslint due to "'MarkerClusterer' is not defined" and
      // 'OverlappingMarkerSpiderfier' warnings.
      /* eslint-disable */
      var markerCluster = new MarkerClusterer(map, [], {
        imagePath: '/themes/custom/tnvacation/img/trails-byways-map/icon-trail-marker-cluster',
        ignoreHidden: true,
        maxZoom: 14,
        styles: [
          {
            url: '/themes/custom/tnvacation/img/trails-byways-map/icon-trail-marker-cluster.png',
            height: 54,
            width: 54,
            anchorText: [-3, 0],
            textColor: '#FFFFFF',
            textSize: 22
          }
        ]
      });

      // Create OverlappingMarkerSpiderfier instsance
      var markerSpiderfier = new OverlappingMarkerSpiderfier(map, {
        circleFootSeparation: 50,
        markersWontMove: true,
        markersWontHide: false
      });
      /* eslint-enable */

      // Track the map instance, trail and location data for later use.
      Drupal.behaviors.componentTrailMap.trails = trails;
      Drupal.behaviors.componentTrailMap.trailLocations[trailId] = trailLocations;
      Drupal.behaviors.componentTrailMap.trailMaps[instanceId] = map;
      Drupal.behaviors.componentTrailMap.trailMapMarkerClusters[instanceId] = markerCluster;
      Drupal.behaviors.componentTrailMap.trailMapMarkerSpiderfier[instanceId] = markerSpiderfier;

      var infowindow = new google.maps.InfoWindow();
      var i = 0;
      var markers = [];
      var latLngArray = [];

      $trailElement.find('.component-trail__trail-list-item--placeholder').remove();

      // Add each location to the map and to the locations list.
      $.each(trailLocations, function (locationId, location) {
        // Skip location if the latitude or longitude are not set.
        if (location.geolocation.lat === null || location.geolocation.lng === null) {
          return true;
        }

        // Create location item and then add to location list.
        $trailElement.find('.component-trail__trail-list > ul').append(Drupal.behaviors.componentTrailMap.createLocationItem(location, i));

        // Set info window content.
        var infowWindowContent = '<p><strong>' + location.content.title + '</strong></br>';
        if (typeof location.contact !== 'undefined') {
          if (typeof location.contact.address_line !== 'undefined' && location.contact.address_line !== null) {
            infowWindowContent += location.contact.address_line + '</br>';
          }
          if (typeof location.contact.locality !== 'undefined' && typeof location.contact.administrative_area !== 'undefined' && typeof location.contact.postal_code !== 'undefined'
            && location.contact.locality !== null && location.contact.administrative_area !== null && location.contact.postal_code !== null) {
            infowWindowContent += location.contact.locality + ', ' + location.contact.administrative_area + ' ' + location.contact.postal_code + '</br>';
          }
          if (typeof location.contact.phone_number !== 'undefined' && location.contact.phone_number !== null) {
            infowWindowContent += '<a href="tel:' + location.contact.phone_number + '" class="gmaps-infowindow-phone">' + location.contact.phone_number + '</a>';
          }
          infowWindowContent += '</p>';
          if (typeof location.contact.page_link !== 'undefined' && location.contact.page_link !== null) {
            infowWindowContent += '<a href="' + location.contact.page_link + '">Learn More</a>';
          }
        }

        // Create marker for location.
        var marker = new google.maps.Marker({
          position: {
            lat: location.geolocation.lat,
            lng: location.geolocation.lng
          },
          title: location.content.title,
          icon: '/themes/custom/tnvacation/img/trails-byways-map/icon-trail-marker-note.png',
          id: locationId,
          markerListPosition: i
        });

        markers.push(marker);

        // Add to latLngArray.
        latLngArray.push({
          lat: location.geolocation.lat,
          lng: location.geolocation.lng
        });

        // Add click event for marker to open location detail panel.
        marker.addListener('click', function () {
          Drupal.behaviors.componentTrailMap.showLocationDetail(instanceId, locationId);
        });

        google.maps.event.addListener(marker, 'click', (function (marker) {
          return function () {
            infowindow.setContent(infowWindowContent);
            infowindow.open(map, marker);
          };
        })(marker));

        // Track marker for later.
        setNestedValue(Drupal.behaviors.componentTrailMap.trailMapMarkers, [instanceId, locationId], marker);

        // Add marker to marker clusterer.
        markerCluster.addMarker(marker);

        // Add marker to marker spiderfier.
        markerSpiderfier.addMarker(marker);

        google.maps.event.addListener(marker, 'mouseover', (function (marker) {
          return function () {
            marker.setIcon('/themes/custom/tnvacation/img/trails-byways-map/icon-trail-marker-selected.png');
          };
        })(marker));

        google.maps.event.addListener(marker, 'mouseout', (function (marker) {
          return function () {
            if (Number($('.trail-location-detail').data('location-id')) !== Number(marker.id)) {
              marker.setIcon('/themes/custom/tnvacation/img/trails-byways-map/icon-trail-marker-note.png');
            }
            else if ($('.trail-location-detail').length === 0) {
              marker.setIcon('/themes/custom/tnvacation/img/trails-byways-map/icon-trail-marker-note.png');
            }
          };
        })(marker));

        google.maps.event.addListener(markerCluster, 'mouseover', function (c) {
          c.clusterIcon_.div_.firstChild.src = '/themes/custom/tnvacation/img/trails-byways-map/icon-trail-marker-cluster-active.png';
        });

        google.maps.event.addListener(markerCluster, 'mouseout', function (c) {
          c.clusterIcon_.div_.firstChild.src = '/themes/custom/tnvacation/img/trails-byways-map/icon-trail-marker-cluster.png';
        });

        // This is setting the active (hover) color on clusters / pins when hovering over list item.
        $(once('trial-list-item-hover', '.component-trail__trail-list-item')).hover(function (event) {
          markers[$(this).data('marker-id')].setIcon('/themes/custom/tnvacation/img/trails-byways-map/icon-trail-marker-selected.png');
          if (typeof markerCluster.clusters_[$(this).data('cluster')] !== 'undefined' && markerCluster.clusters_[$(this).data('cluster')].clusterIcon_.div_.firstChild !== null) {
            markerCluster.clusters_[$(this).data('cluster')].clusterIcon_.div_.firstChild.src = '/themes/custom/tnvacation/img/trails-byways-map/icon-trail-marker-cluster-active.png';
          }
        },
        function () {
          if ($('.trail-location-detail').length === 0) {
            markers[$(this).data('marker-id')].setIcon('/themes/custom/tnvacation/img/trails-byways-map/icon-trail-marker-note.png');
            if (markerCluster.clusters_[$(this).data('cluster')].clusterIcon_.div_.firstChild !== null) {
              markerCluster.clusters_[$(this).data('cluster')].clusterIcon_.div_.firstChild.src = '/themes/custom/tnvacation/img/trails-byways-map/icon-trail-marker-cluster.png';
            }
          }
        });

        i++;

      });

      Drupal.behaviors.componentTrailMap.trailLocationsLatLng = latLngArray;

      Drupal.behaviors.componentTrailMap.clusterCheck(markerCluster, markers);

      google.maps.event.addListener(map, 'bounds_changed', function () {
        Drupal.behaviors.componentTrailMap.clusterCheck(markerCluster, markers);
      });

      // Reorder location Items based on distance to map center.
      Drupal.behaviors.componentTrailMap.reorderLocationItems(instanceId);

      // Add click event for location list item to open location detail panel.
      $trailElement.on('click', 'li.component-trail__trail-list-item', function () {
        Drupal.behaviors.componentTrailMap.showLocationDetail(instanceId, $(this).data('location-id'));
        return false;
      });

      $trailElement.on('focus', 'li.component-trail__trail-list-item', function () {
        if ($('body').hasClass('jsa-keyboard-activated')) {
          $(this).addClass('focused');
        }
      }).on('blur', 'li.component-trail__trail-list-item', function () {
        if ($('body').hasClass('jsa-keyboard-activated')) {
          $(this).removeClass('focused');
        }
      });

      // Add click event for location detail panel button to hide itself.
      $trailElement.on('click', 'button.trail-location-detail__back-button', function () {
        Drupal.behaviors.componentTrailMap.hideLocationDetail(instanceId, $(this).parent().find('.trail-location-detail__trip-planner-button').data('entity-id'));
        return false;
      });

      google.maps.event.addListener(map, 'click', function (event) {
        infowindow.close();
      });

      $(document).mouseup(function (event) {
        var container = $('.component-trail__map');
        if (!container.is(event.target) && container.has(event.target).length === 0) {
          infowindow.close();
        }
      });

      // Initialize timeout timer (to help center_changed from repeated fire).
      Drupal.behaviors.componentTrailMap.trailMapTimeout[instanceId] = null;

      // Track when map center has changed.
      map.addListener('center_changed', function () {
        clearTimeout(Drupal.behaviors.componentTrailMap.trailMapTimeout[instanceId]);
        Drupal.behaviors.componentTrailMap.trailMapTimeout[instanceId] = setTimeout(function () {
          Drupal.behaviors.componentTrailMap.reorderLocationItems(instanceId);
        }, 300);
      });

      // Track when user has dragged the map.
      google.maps.event.addListener(map, 'dragend', function () {
        // Clean previous map settings if user purposely drags the map.
        setNestedValue(Drupal.behaviors.componentTrailMap.trailMapSettings, [instanceId, 'center'], null);
        setNestedValue(Drupal.behaviors.componentTrailMap.trailMapSettings, [instanceId, 'scroll'], 0);
      });

      // Track that this trail was processed.
      $trailElement.addClass('component-trail--processed');
      $trailElement.find('.initializing').addClass('visually-hidden').html('Experience loaded.');

      // Track if we should redirect to a new trail.
      $('.form-item-trail', $trailElement).pSelect({
        default: null,
        onChange: function (option) {
          window.location.href = option.data('filterValue');
        }
      });

      // Initialize filtering.
      var defaultFilterCategories = [];
      if ($.urlParam('category') !== null) {
        defaultFilterCategories = $.urlParam('category').split(',');
      }

      var $trailFormSummary = $('.component-trail__form-summary', $trailElement);
      var $trailFormSummaryCategoryListElement = $('.component-trail__form-summary-category-list', $trailElement);

      // Track if we should filter by category.
      $('.form-item-filter', $trailElement).pOptions({
        default: {
          category: defaultFilterCategories
        },
        onChange: function (option) {
          var $optionTrailElement = $(option).parents('.component-trail');
          var filterInstanceId = $optionTrailElement.attr('data-instance-id');
          var filterData = $('.form-item-filter', $optionTrailElement).data();
          var filterCategories = getNestedValue(filterData, ['pOptions', 'value', 'category'], []);
          var $locationDetail = $optionTrailElement.find('.trail-location-detail');

          // If detail page is open, close it on filter interaction.
          if ($locationDetail.length > 0) {
            Drupal.behaviors.componentTrailMap.hideLocationDetail(instanceId, $locationDetail.data('location-id'));
          }

          Drupal.behaviors.componentTrailMap.filterMapLocations(filterInstanceId, filterCategories);

          // Filter categories by if they exist and then sort by title.
          filterCategories = filterCategories.filter(function (id) {
            return (drupalSettings.tnv_trails.content_categories.hasOwnProperty(id));
          }).sort(function (a, b) {
            if (drupalSettings.tnv_trails.content_categories[a].title < drupalSettings.tnv_trails.content_categories[b].title) {
              return -1;
            }
            if (drupalSettings.tnv_trails.content_categories[a].title > drupalSettings.tnv_trails.content_categories[b].title) {
              return 1;
            }
            return 0;
          });

          if (filterCategories !== []) {
            $trailFormSummary.addClass('js-active');
          }
          else {
            $trailFormSummary.removeClass('js-active');
          }


          // Wipe previous elements to re-add them.
          $trailFormSummaryCategoryListElement.find('li').remove();

          // Add categories to list.
          for (var filterCategoriesKey in filterCategories) {
            if (filterCategories.hasOwnProperty(filterCategoriesKey)) {
              var filterCategory = drupalSettings.tnv_trails.content_categories[filterCategories[filterCategoriesKey]];
              var locationTypeListItem = document.createElement('li');
              locationTypeListItem.innerHTML = filterCategory.title;
              locationTypeListItem.setAttribute('data-location-type-id', filterCategory.id);
              $trailFormSummaryCategoryListElement.append(locationTypeListItem);
            }
          }
        },
        onClear: function () {
          var filterInstanceId = $trailElement.attr('data-instance-id');
          var $locationDetail = $trailElement.find('.trail-location-detail');

          // If detail page is open, close it on filter interaction.
          if ($locationDetail.length > 0) {
            Drupal.behaviors.componentTrailMap.hideLocationDetail(instanceId, $locationDetail.data('location-id'));
          }

          Drupal.behaviors.componentTrailMap.filterMapLocations(filterInstanceId, []);
          $trailFormSummaryCategoryListElement.find('li').remove();
          $trailFormSummary.removeClass('js-active');
        }
      });

      // Add the TMP filter button because we don't want to hard code it in the template
      $('.form-item-filter', $trailElement).find('.poptions__options').append('<a href="#" class="button tmp-filter-close-button" tabindex="-1">View Selections</a>');

      $('.tmp-filter-close-button').on('click', function (e) {
        var filterPlugin = $('.form-item-filter', $trailElement).data('pOptions');
        filterPlugin.toggle(false);
        e.preventDefault();
      });

      // Add click event for category pills to disable themselves.
      $trailFormSummaryCategoryListElement.on('click', 'li', function () {
        var filterPlugin = $('.form-item-filter', $trailElement).data('pOptions');
        var filterPluginOption = filterPlugin.getOption('category', $(this).data('location-type-id'));
        var selectedCategory = $(this).data('location-type-id');
        filterPlugin.unselect(filterPluginOption);
        $('.modal[data-filter-name="location-type"]', $trailElement).find('input[type=checkbox][value=' + selectedCategory + ']').prop('checked', false);
      });

      // Add click event for category clear to remove the category pills.
      $('.component-trail__form-summary-category-clear', $trailElement).on('click', function () {
        var filterPlugin = $('.form-item-filter', $trailElement).data('pOptions');
        filterPlugin.clear();
        $('.modal[data-filter-name="location-type"]', $trailElement).find('input[type=checkbox]').each(function () {
          $(this).prop('checked', false);
        });
      });

      $('.poptions__clear.tmp-filters.active', $trailElement).on('click', function () {
        $('.modal[data-filter-name="location-type"]', $trailElement).find('input[type=checkbox]').each(function () {
          $(this).prop('checked', false);
        });
      });

      // Track if we should filter by location.
      var defaultLocation = null;

      if ($.urlParam('selected-region') !== null) {
        defaultLocation = $.urlParam('selected-region');
      }

      $('.form-item-going', $trailElement).pSelect({
        default: defaultLocation,
        searchElement: $('.form-item-going-city-search', $trailElement),
        searchElementRegex: /^(\([0-9.,\- ]+\)) (.*)/g,
        onChange: function (option) {
          if (option[0].dataset.filterType !== 'cities' && option.data('filterValue')) {
            window.location.href = option.data('filterValue');
          }
          else {
            var $locationDetail = $trailElement.find('.trail-location-detail');

            // If detail page is open, close it on filter interaction.
            if ($locationDetail.length > 0) {
              Drupal.behaviors.componentTrailMap.hideLocationDetail(instanceId, $locationDetail.data('location-id'));
            }

            Drupal.behaviors.componentTrailMap.filterMapGeolocation($trailElement.attr('data-instance-id'));
          }
        },
        onClear: function (plugin) {
          var $filterTrailElement = $(plugin.element).parents('.component-trail');
          var $locationDetail = $trailElement.find('.trail-location-detail');

          // If detail page is open, close it on filter interaction.
          if ($locationDetail.length > 0) {
            Drupal.behaviors.componentTrailMap.hideLocationDetail(instanceId, $locationDetail.data('location-id'));
          }

          Drupal.behaviors.componentTrailMap.filterMapGeolocation($filterTrailElement.attr('data-instance-id'));
        }
      });

      // Resize map to make sure all of Tennessee is in-bounds.
      Drupal.behaviors.componentTrailMap.positionMap(instanceId, null, null, latLngArray);

      // Trigger filterMapGeolocation on init.
      Drupal.behaviors.componentTrailMap.filterMapGeolocation($trailElement.attr('data-instance-id'));

      // Set up toggle for trail featured-on.
      $trailElement.find('.component-trail__detail').on('click', '.toggle', function () {
        $(this).parents('.trail-location-detail-featured-on').attr('data-list-status', $(this).hasClass('toggle--more') ? 'open' : 'closed');
      });

      // Add search by attraction feature
      $('input[data-drupal-selector=edit-attraction-search]').on('autocompleteclose', function (e) {
        var str = e.target.value;
        var locationId = str.substring(0, str.indexOf(','));
        var textToDisplay = str.split(', ').pop();

        if (textToDisplay) {
          if (locationId) {
            Drupal.behaviors.componentTrailMap.showLocationDetail(instanceId, locationId);

            dataLayer.push({
              eventCategory: 'trails',
              eventAction: 'i want to see',
              eventLabel: textToDisplay,
              eventvalue: '',
              event: 'eventClick'
            });
          }
          $(this).val(textToDisplay);
          $(this).parent().find('.pselect-clear').addClass('active');
        }
      });

      // Search by attraction clear form
      $('.js-form-item-attraction-search .pselect-clear').on('click', function (e) {
        e.preventDefault();
        var $locationDetail = $trailElement.find('.trail-location-detail');
        Drupal.behaviors.componentTrailMap.hideLocationDetail(instanceId, $locationDetail.data('location-id'));
      });

      // Init mobile filtering
      Drupal.behaviors.componentTrailMap.initializeMobileFilters($trailElement);
      Drupal.behaviors.componentTrailMap.mobileFilterClickEvents($trailElement);
      $(window).resize(function () {
        Drupal.behaviors.componentTrailMap.initializeMobileFilters($trailElement);
      });
    },

    /**
     * Check the position of a marker within a cluster, if applicable.
     *
     * @param {object} markerCluster
     *   The Marketcluster object.
     * @param {array} markers
     *   The markers array.
     */
    clusterCheck: function (markerCluster, markers) {

      function markerPositionFinder(markerClusterSubset, index) {
        $('.component-trail__trail-list-item').each(function () {
          var markerPosition = $(this).data('marker-id');
          if (typeof $(this).data('data-cluster') !== 'undefined') {
            $(this).removeAttr('data-cluster');
          }
          for (var i = 0; i < markerClusterSubset.length; ++i) {
            if (markerClusterSubset[i]['markerListPosition'] === markerPosition) {
              $(this).attr('data-cluster', index); // sets
            }
          }
        });
      }

      var clusters = [];
      if (markerCluster['clusters_'].length > 0) {
        clusters = markerCluster['clusters_'];
        // Take each marker, determine cluster
        var markersList = [];
        // Loop through clusters
        for (var i = 0; i < clusters.length; ++i) {
          markersList[i] = clusters[i]['markers_'];
        }
        for (var i2 = 0; i2 < markersList.length; ++i2) {
          markerPositionFinder(markersList[i2], i2);
        }
      }
      else {
        window.setTimeout(function () {
          Drupal.behaviors.componentTrailMap.clusterCheck(markerCluster);
        }, 1000);
      }
    },

    /**
     * Build a map toggle for mobile users.
     *
     */
    createToggle: function () {

      var toggle = $('.map-toggle');
      var map = $('.component-trail__map-wrapper');

      // Make the List View tab red on load.
      $('.map-toggle-bar__list-view').addClass('active-tab');

      toggle.on('click', function (e) {
        $('body').toggleClass('trail-map-active');
        $(map).toggleClass('map-active');
        if ($(map).hasClass('map-active')) {
          $('.map-toggle-bar__map-view').addClass('active-tab');
          $('.map-toggle-bar__list-view').removeClass('active-tab');
        }
        if (!$(map).hasClass('map-active')) {
          $('.map-toggle-bar__list-view').addClass('active-tab');
          $('.map-toggle-bar__map-view').removeClass('active-tab');
        }
      });
    },

    /**
     * Create's a trail location's list item for the trail location list.
     *
     * @param {object} location
     *   The trail location object.
     * @param {string} markerPosition
     *   The index of the locations marker in the google maps marker array.
     * @return {Node}
     *   A li document fragment.
     */
    createLocationItem: function (location, markerPosition) {
      // Create location item from template and update with location content.
      var locationItem = document.getElementById('component-trail__trail-location').content.cloneNode(true);
      locationItem.querySelector('li').setAttribute('data-location-id', location.id);
      locationItem.querySelector('li').setAttribute('data-marker-id', markerPosition);
      locationItem.querySelector('.trail-location-detail__title-city').innerHTML = location.contact.locality;
      locationItem.querySelector('.trail-location-item__title').innerHTML = location.content.title;
      locationItem.querySelector('.trail-location-item__content').innerHTML = location.content.description_short.substring(0, 76);
      if (location.content.img_detail_small !== null && location.content.img_detail_small.length > 0) {
        locationItem.querySelector('.trail-location-item__image').innerHTML = location.content.img_detail_small;
      }
      else {
        locationItem.querySelector('.trail-location-item__image').style.display = 'none';
      }

      $.each(location.tagging.type, function (locationTypeId, locationTypeData) {
        if (locationTypeId in drupalSettings.tnv_trails.content_categories) {
          locationItem.querySelector('.trail-location-item__meta-tags').insertAdjacentHTML('beforeend', '<li data-location-type-id="' + locationTypeId + '">' + drupalSettings.tnv_trails.content_categories[locationTypeId].title + '</li>');
        }
      });

      return locationItem;
    },

    /**
     * Reorders a list of trail locations on a trail component.
     *
     * @param {string} instanceId
     *   The trail jQuery object.
     */
    reorderLocationItems: function (instanceId) {
      // Get trail element and ID.
      var $trailElement = Drupal.behaviors.componentTrailMap.getTrailElement(instanceId);
      var trailId = $trailElement.data('trail-id');

      // Determine map center.
      var mapCenter = Drupal.behaviors.componentTrailMap.getTrailMap(instanceId).getCenter();

      // Calculate each locations distance from the center of the map.
      $trailElement.find('.component-trail__trail-list-item').each(function () {
        var locationId = $(this).data('location-id');
        var location = Drupal.behaviors.componentTrailMap.getTrailLocation(trailId, locationId);
        this.dataset.distance = calculateDistance(mapCenter.lat(), mapCenter.lng(), location.geolocation.lat, location.geolocation.lng);
      });

      // Sort the location items.
      var listItems = $trailElement.find('.component-trail__trail-list-item').get();
      listItems.sort(function (a, b) {
        if (parseFloat(a.dataset.distance) < parseFloat(b.dataset.distance)) {
          return -1;
        }
        else if (parseFloat(a.dataset.distance) > parseFloat(b.dataset.distance)) {
          return 1;
        }
        return 0;
      });

      // Reorder the location list items.
      var $listContainer = $trailElement.find('.component-trail__trail-list > ul');
      $.each(listItems, function (index, item) {
        $listContainer.append(item);
      });

      // Figure out if the list should be reset to a previous position.
      var mapLocationScroll = getNestedValue(Drupal.behaviors.componentTrailMap.trailMapSettings, [instanceId, 'scroll'], 0);
      // If a detail isn't being shown, reset scroll.
      if (typeof $trailElement.data('detail-location-id') === 'undefined') {
        setNestedValue(Drupal.behaviors.componentTrailMap.trailMapSettings, [instanceId, 'scroll'], 0);
      }

      // Scroll to the list to either the previous position or top.
      $trailElement.find('.component-trail__trail-list').scrollTop(mapLocationScroll);
      // Generate nearby items.
      Drupal.behaviors.componentTrailMap.nearbyItems(drupalSettings.trailLocations, instanceId, mapCenter);

      if ($('body').hasClass('jsa-keyboard-activated')) {
        $.each(listItems, function (index, item) {
          if ($(this).hasClass('focused')) {
            $(this).find('button.trail-location-item__read-more-button').focus();
          }
        });
      }
    },

    nearbyItems: function (locations, instanceId, mapCenter) {
      // Get trail element and ID.
      var $trailElement = Drupal.behaviors.componentTrailMap.getTrailElement(instanceId);
      var trailId = $trailElement.data('trail-id');
      var nearbyListingsSection = $('.trail-location-detail-nearby-listings');
      var newItems = [];
      var closestItems = [];
      var i = 0;
      // Filter through locations and compare distances to find locations
      // within 60 miles of the selected location
      $.each(locations, function (index, item) {
        var locationId = item.id;
        var location = Drupal.behaviors.componentTrailMap.getTrailLocation(trailId, locationId);
        item.distance = calculateDistance(mapCenter.lat(), mapCenter.lng(), location.geolocation.lat, location.geolocation.lng);
        item.distanceMiles = Math.round(item.distance * 0.62137);
        // Add them if they are within 60 miles
        if (item.distanceMiles <= 60) {
          newItems.push(item);
        }
      });
      // Sort the new list from closest to furthest and create a final list
      newItems.sort(function (a, b) {
        if (parseFloat(a.distance) < parseFloat(b.distance)) {
          return -1;
        }
        else if (parseFloat(a.distance) > parseFloat(b.distance)) {
          return 1;
        }
        return 0;
      });
      $.each(newItems, function (index, item) {
        if (i < 4 && i !== 0) {
          closestItems.push(item);
        }
        i++;
      });
      // Build closest item detail listings.
      if ($(nearbyListingsSection).children('.trail-location-detail-nearby-listing').length === 0) {
        $.each(closestItems, function (index, item) {
          // Create new nearby listing element from template.
          var nearbyListing = document.getElementById('component-trail__trail-location-detail-nearby-listing').content.cloneNode(true);
          nearbyListing.querySelector('.trail-location-detail-nearby-listing__trail-stop-marker--miles').innerHTML = item.distanceMiles;
          nearbyListing.querySelector('.trail-location-detail-nearby-listing-title').innerHTML = item.content.title;
          nearbyListing.querySelector('.trail-location-detail-nearby-listing').setAttribute('data-location-id', item.id);
          $.each(item.tagging.type, function (index, type) {
            var locationTypeId = type.id;
            if (locationTypeId in drupalSettings.tnv_trails.content_categories) {
              var listElement = document.createElement('li');
              var listElementContent = document.createTextNode(drupalSettings.tnv_trails.content_categories[locationTypeId].title);
              listElement.appendChild(listElementContent);
              nearbyListing.querySelector('.trail-location-detail-nearby-listing-tags-list').appendChild(listElement);
            }
          });
          // Add list of nearby listings.
          $(nearbyListingsSection).append(nearbyListing);
        });
      }

      // Add click event for location list item to open location detail panel.
      $('.trail-location-detail-nearby-listing').on('click', function () {
        sessionStorage.locationID = $(this).data('location-id');
        Drupal.behaviors.componentTrailMap.hideLocationDetail(instanceId, $(this).parent().parent().parent().find('.trail-location-detail__trip-planner-button').data('entity-id'));
        setTimeout(function () {
          Drupal.behaviors.componentTrailMap.showLocationDetail(instanceId, sessionStorage.locationID);
          $([document.documentElement, document.body]).animate({
            scrollTop: $('.component-trail__content').offset().top
          }, 500);
        }, 600);
        return false;
      });
    },

    /**
     * Builds a trail location's detail element.
     *
     * @param {string} instanceId
     *   The Trail instance ID.
     * @param {number} locationId
     *   The Trail location ID.
     *
     * @return {Node}
     *   The trail location's detail element.
     */
    buildLocationDetailElement: function (instanceId, locationId) {
      // Load trail and location information.
      var $trailElement = Drupal.behaviors.componentTrailMap.getTrailElement(instanceId);
      var trailId = $trailElement.data('trail-id');
      var location = Drupal.behaviors.componentTrailMap.getTrailLocation(trailId, locationId);

      // Create new detail element from template.
      var detailElement = document.getElementById('component-trail__trail-location-detail').content.cloneNode(true);

      // Set header title and city.
      detailElement.querySelector('.trail-location-detail__title-label').innerHTML = location.content.title;
      if (!$.isEmptyObject(location.tagging.city)) {
        var cityId = Object.keys(location.tagging.city)[0];
        detailElement.querySelector('.trail-location-detail__title-city').innerHTML = location.tagging.city[cityId].title;
      }

      // Get image from location content.
      var image_output = null;
      var image_path_is_custom = false;
      if (location.content.img_detail_large !== null && location.content.img_detail_large.length > 0) {
        image_output = location.content.img_detail_large;
        image_path_is_custom = true;
      }
      // Trails do not have default marker images like TMP.
      // Otherwise get image from the first category that has an image.
      // else {
      //   for (var locationTaggingTypeId in location.tagging.type) {
      //     if (location.tagging.type.hasOwnProperty(locationTaggingTypeId) && drupalSettings.tnv_trails.content_categories.hasOwnProperty(locationTaggingTypeId)) {
      //       if (drupalSettings.tnv_trails.content_categories[locationTaggingTypeId].image !== null) {
      //         image_path = drupalSettings.tnv_trails.content_categories[locationTaggingTypeId].image;
      //         break;
      //       }
      //     }
      //   }
      // }

      // Set image if we an image path was found.
      if (image_output !== null) {
        detailElement.querySelector('.trail-location-detail__title').innerHTML = image_output;
        if (image_path_is_custom) {
          detailElement.querySelector('.trail-location-detail__title').classList.add('trail-location-detail__title--with-image');
        }
      }
      else {
        // If no image path, then remove the background image and shorten height.
        $(detailElement.querySelector('.trail-location-detail__title')).css({
          'background-image': 'none',
          'height': '2vw',
          'min-height': 'unset'
        });
        detailElement.querySelector('.trail-location-detail').classList.add('no-image');
      }

      // Add mytrip id.
      var mtbutton = detailElement.querySelectorAll('.mytrip');
      for (var i = 0; i < mtbutton.length; i++) {
        mtbutton[i].setAttribute('data-entity-id', locationId);
        mtbutton[i].setAttribute('aria-label', 'Add or remove ' + location.content.title + ' from My Trip');
      }

      // Add list of trails.
      for (var locationTrailId in location.tagging.trail) {
        if (Drupal.behaviors.componentTrailMap.trails.hasOwnProperty(locationTrailId)) {
          var locationTrail = Drupal.behaviors.componentTrailMap.trails[locationTrailId];

          // Create link to the trail.
          var locationTrailLink = document.createElement('a');
          locationTrailLink.innerHTML = locationTrail.content.title;
          locationTrailLink.href = locationTrail.path;
          locationTrailLink.style.backgroundImage = null;

          // Create list item and place link into it.
          var locationTrailListItem = document.createElement('li');
          locationTrailListItem.appendChild(locationTrailLink);

          // Place list item into list.
          detailElement.querySelector('.trail-location-detail-featured-on__list').appendChild(locationTrailListItem);
        }
      }

      // Add content.
      detailElement.querySelector('.trail-location-detail__content-description').innerHTML = location.content.description;

      // Update more-info link.
      if (location.path !== null && location.path.length > 0) {
        var learnMoreButton = detailElement.querySelector('.trail-location-detail__content-buttons-button--more-info');
        var buttonText = Drupal.t('Learn more about @location', {'@location': location.content.title});
        learnMoreButton.href = location.path;
        learnMoreButton.setAttribute('aria-label', buttonText);
      }
      else {
        detailElement.querySelector('.trail-location-detail__content-buttons-button--more-info').parentNode.removeChild(detailElement.querySelector('.trail-location-detail__content-buttons-button--more-info'));
      }

      // Update the Events link for a partner.
      if (location.content.has_events === true) {
        detailElement.querySelector('.trail-location-detail__content-href--events').href = '/calendar?field_event_partner_target_id=' + location.id;
      }
      else {
        $(detailElement.querySelector('.trail-location-detail__content-hrefs').firstChild).hide();
      }

      // Update directions link.
      detailElement.querySelector('.trail-location-detail__content-href--directions').href = location.geolocation.path_directions;

      // Add location type tags.
      for (var locationTypeId in location.tagging.type) {
        if (location.tagging.type.hasOwnProperty(locationTypeId) && (locationTypeId in drupalSettings.tnv_trails.content_categories)) {
          var locationTypeListItem = document.createElement('li');
          locationTypeListItem.innerHTML = drupalSettings.tnv_trails.content_categories[locationTypeId].title;
          locationTypeListItem.setAttribute('data-location-type-id', locationTypeId);
          detailElement.querySelector('.trail-location-detail-tags__list').appendChild(locationTypeListItem);
        }
      }

      // Add marker position identifier
      var marker = Drupal.behaviors.componentTrailMap.getTrailMarker(instanceId, locationId);
      detailElement.querySelector('.trail-location-detail').setAttribute('data-marker-id', marker.markerListPosition);
      detailElement.querySelector('.trail-location-detail').setAttribute('data-location-id', locationId);

      return detailElement;
    },

    /**
     * Show a location detail panel based on trail and location ID.
     *
     * @param {string} instanceId
     *   The Trail instance ID.
     * @param {number} locationId
     *   The Trail location ID.
     */
    showLocationDetail: function (instanceId, locationId) {
      if (activeIcon) {
        var activeMarker = Drupal.behaviors.componentTrailMap.getTrailMarker(instanceId, activeIcon);
        activeMarker.setIcon('/themes/custom/tnvacation/img/trails-byways-map/icon-trail-marker-note.png');
      }
      var map = Drupal.behaviors.componentTrailMap.getTrailMap(instanceId);
      var marker = Drupal.behaviors.componentTrailMap.getTrailMarker(instanceId, locationId);
      marker.setIcon('/themes/custom/tnvacation/img/trails-byways-map/icon-trail-marker-selected.png');
      activeIcon = locationId;

      var $trailElement = Drupal.behaviors.componentTrailMap.getTrailElement(instanceId);
      var $trailDetailContainerElement = $trailElement.find('.component-trail__detail');

      var trailId = $trailElement.data('trail-id');
      var location = Drupal.behaviors.componentTrailMap.getTrailLocation(trailId, locationId);

      // Don't rebuild detail element if it's already selected.
      if ($trailElement.data('detail-location-id') === locationId) {
        return;
      }

      // Track map settings if location detail is currently not already shown.
      if (typeof $trailElement.data('detail-location-id') === 'undefined') {
        setNestedValue(Drupal.behaviors.componentTrailMap.trailMapSettings, [instanceId, 'center'], map.getCenter());
        setNestedValue(Drupal.behaviors.componentTrailMap.trailMapSettings, [instanceId, 'scroll'], $trailElement.find('.component-trail__trail-list').scrollTop());
        setNestedValue(Drupal.behaviors.componentTrailMap.trailMapSettings, [instanceId, 'zoom'], map.getZoom());
      }

      // Create detail item from template and update with location content.
      var detailElement = Drupal.behaviors.componentTrailMap.buildLocationDetailElement(instanceId, locationId);

      // Wipe detail container, add new element, track location ID & visibility.
      $trailDetailContainerElement.html('');
      $trailDetailContainerElement.append(detailElement);
      $trailElement.data('detail-location-id', locationId);
      $trailElement.addClass('component-trail--location-detail-visible');

      if ($('body').hasClass('jsa-keyboard-activated')) {
        var $backButton = $trailElement.find('.trail-location-detail__back-button');
        $backButton.focus();
      }

      // Initialize MyTrip.
      Drupal.behaviors.myTripLinks.attach();

      // Zoom in to marker on map.
      map.setZoom(17);
      map.setCenter(marker.getPosition());

      // Trigger trail list by calling window resize.
      $(window).resize();

      // Track analytics (easier since map instance required to track click).
      dataLayer.push({
        eventCategory: 'trails',
        eventAction: 'trail location click',
        eventLabel: location.content.title,
        eventvalue: '',
        event: 'eventClick'
      });
    },

    /**
     * Hide the location detail panel of a trail instance.
     *
     * @param {string} instanceId
     *   The Trail instance ID.
     * @param {number} locationId
     *   The Trail location ID.
     */
    hideLocationDetail: function (instanceId, locationId) {
      var map = Drupal.behaviors.componentTrailMap.getTrailMap(instanceId);
      var marker = Drupal.behaviors.componentTrailMap.getTrailMarker(instanceId, locationId);
      var $trailElement = Drupal.behaviors.componentTrailMap.getTrailElement(instanceId);
      var $trailDetailContainerElement = $trailElement.find('.component-trail__detail');

      if (marker) {
        marker.setIcon('/themes/custom/tnvacation/img/trails-byways-map/icon-trail-marker-note.png');
      }

      // Hide old element.
      $trailElement.removeClass('component-trail--location-detail-visible');
      $trailElement.removeData('detail-location-id');

      // Clear filter
      var autocompleFilter = $('input[data-drupal-selector=edit-attraction-search]').val();

      if (typeof autocompleFilter !== 'undefined') {
        $('input[data-drupal-selector=edit-attraction-search]').val('');
      }

      $('.js-form-item-attraction-search .pselect-clear').removeClass('active');

      // Allow element to hide before removing element.
      setTimeout(function () {
        $trailDetailContainerElement.html('');
      }, 500);

      // Get map center and zoom level from previous map settings. Center
      // defaults to current map center and zoom defaults to 15.
      var mapCenter = getNestedValue(Drupal.behaviors.componentTrailMap.trailMapSettings, [instanceId, 'center'], map.getCenter());
      var mapZoom = getNestedValue(Drupal.behaviors.componentTrailMap.trailMapSettings, [instanceId, 'zoom'], 15);

      // Clean previous map settings.
      setNestedValue(Drupal.behaviors.componentTrailMap.trailMapSettings, [instanceId, 'center'], null);
      setNestedValue(Drupal.behaviors.componentTrailMap.trailMapSettings, [instanceId, 'zoom'], null);

      // Make sure map zoom isn't too zoomed-in (marker clusters can act weird).
      if (mapZoom > 15) {
        mapZoom = 15;
      }

      // Reset map to previous settings
      map.setCenter(mapCenter);
      map.setZoom(mapZoom);

      if ($('body').hasClass('jsa-keyboard-activated')) {
        $('li.component-trail__trail-list-item[data-location-id="' + locationId + '"]').addClass('focused');
      }
    },

    /**
     * Get's a geolocation object with lat lng properties set.
     *
     * @param {jQuery} $option
     *   The option jQuery element.
     *
     * @return {null|Object}
     *   The geolocation object. Null otherwise
     */
    getFilterOptionGeolocation: function ($option) {
      if ($option !== null) {
        if ($option.data('filterType') === 'cities') {
          return {
            lat: parseFloat($option.data('filterValue').split(', ')[0]),
            lng: parseFloat($option.data('filterValue').split(', ')[1])
          };
        }

        return Drupal.behaviors.componentTrailMap.trailGeolocations.directions[$option.data('filterValue')];
      }

      return null;
    },

    /**
     * Reset map bounds based on current filter values.
     *
     * @param {string} instanceId
     *   The Trail instance ID.
     */
    filterMapGeolocation: function (instanceId) {
      var $trailElement = Drupal.behaviors.componentTrailMap.getTrailElement(instanceId);
      var optionGoing = $trailElement.find('.form-item-going').data('pSelect').getValue();
      var selectedRegion;
      var selectedCity;
      var filterGeolocationGoing = null;

      if (optionGoing !== null) {
        if (optionGoing[0].dataset.filterType !== 'cities') {
          selectedRegion = optionGoing[0].dataset.filterValue;
          selectedCity = null;
        }
        if (optionGoing[0].dataset.filterType === 'cities') {
          selectedCity = optionGoing[0].dataset.filterValue;
          selectedRegion = null;
        }
        filterGeolocationGoing = Drupal.behaviors.componentTrailMap.getFilterOptionGeolocation(optionGoing);
        Drupal.behaviors.componentTrailMap.positionMap(instanceId, filterGeolocationGoing, null, null);
        Drupal.behaviors.componentTrailMap.updatePageUrl(instanceId, selectedRegion, selectedCity);
      }

      // This condition should only happen on init, and city filtered.
      else if ($.urlParam('selected-city') !== null) {
        filterGeolocationGoing = {
          lat: parseFloat($.urlParam('selected-city').split(', ')[0]),
          lng: parseFloat($.urlParam('selected-city').split(', ')[1])
        };
        Drupal.behaviors.componentTrailMap.positionMap(instanceId, filterGeolocationGoing, null, null);
      }
    },

    autoInitDirectionFilter: function (location) {
      if (typeof $('.component-trail').attr('data-instance-id') !== 'undefined') {
        var instanceId = $('.component-trail').attr('data-instance-id');
        var filterGeolocationGoing = null;
        var selectedRegion;
        var selectedCity;
        if ($.urlParam('selected-region') !== null) {
          selectedRegion = $.urlParam('selected-region');
          filterGeolocationGoing = Drupal.behaviors.componentTrailMap.getFilterOptionGeolocation(location);
        }
        else if ($.urlParam('selected-city') !== null) {
          selectedCity = $.urlParam('selected-city');
          filterGeolocationGoing = {
            lat: parseFloat($.urlParam('selected-city').split(', ')[0]),
            lng: parseFloat($.urlParam('selected-city').split(', ')[1])
          };
        }

        Drupal.behaviors.componentTrailMap.positionMap(instanceId, filterGeolocationGoing, null, null);
        Drupal.behaviors.componentTrailMap.updatePageUrl(instanceId, selectedRegion, selectedCity);
      }
      else {
        setTimeout(Drupal.behaviors.componentTrailMap.autoInitDirectionFilter(location), 1000);
      }
    },

    /**
     * Filter the markers on the map based on passed in category IDs.
     *
     * @param {string} instanceId
     *   The Trail instance ID.
     * @param {array} categories
     *   The array of category IDs to filter the markers by.
     */
    filterMapLocations: function (instanceId, categories) {
      var trailId = Drupal.behaviors.componentTrailMap.getTrailId(instanceId);
      var $trailElement = Drupal.behaviors.componentTrailMap.getTrailElement(instanceId);
      var trailMarkerCluster = Drupal.behaviors.componentTrailMap.getTrailMarkerCluster(instanceId);
      var totalFilteredStops = 0;

      $.each(Drupal.behaviors.componentTrailMap.getTrailLocations(trailId), function (locationId, location) {
        var marker = Drupal.behaviors.componentTrailMap.getTrailMarker(instanceId, locationId);
        var $trailListItem = $trailElement.find('.component-trail__trail-list-item[data-location-id="' + locationId + '"]');

        // Skip item if marker isn't defined.
        if (typeof marker === 'undefined') {
          return true;
        }

        // Default to attaching location.
        var attach = true;
        var filtered = [];

        // Check if any categories were passed in to filter by.
        if (categories.length > 0) {
          // Find if location matches any of the requested categories.
          filtered = Object.keys(location.tagging.type).filter(function (item) {
            return (categories.indexOf(item) !== -1);
          });

          // Attach if any match.
          attach = (filtered.length > 0);
        }

        // If categories are empty or if ID exists.
        if (attach) {
          marker.setVisible(true);
          $trailListItem.removeClass('component-trail__trail-list-item--hide');
          totalFilteredStops++;
        }
        else {
          marker.setVisible(false);
          $trailListItem.addClass('component-trail__trail-list-item--hide');
        }
      });

      trailMarkerCluster.repaint();

      var $asideTotalStops = $('.component-trail__trail-aside-total-stops', $trailElement);
      var $resultsCategoryContainer = $('.component-trail__form-summary-results-category-container', $trailElement);

      $('.filtered-stop-results', $asideTotalStops).remove();
      $('.component-trail__form-summary-total-results').remove();

      if (totalFilteredStops === 1 && categories.length > 0) {
        $($resultsCategoryContainer).prepend('<p class="component-trail__form-summary-total-results">' + totalFilteredStops + ' Result</p>');
        $($asideTotalStops).prepend('<span class="filtered-stop-results">Showing<span class="total-stops">' + totalFilteredStops + '</span>of</span>');
      }
      else if (totalFilteredStops > 1 && categories.length > 0) {
        $($resultsCategoryContainer).prepend('<p class="component-trail__form-summary-total-results">' + totalFilteredStops + ' Results</p>');
        $($asideTotalStops).prepend('<span class="filtered-stop-results">Showing <span class="total-stops">' + totalFilteredStops + '</span> of </span>');
      }


      Drupal.behaviors.componentTrailMap.updatePageUrl(instanceId);
    },

    /**
     * Update's the page URL based on passed-in instance IDs filters.
     *
     * @param {string} instanceId
     *   The Trail instance ID.
     * @param {null|string} selectedRegion
     *   The selected region.
     * @param {null|string} selectedCity
     *   The selected city.
     */
    updatePageUrl: function (instanceId, selectedRegion, selectedCity) {
      var $trailElement = Drupal.behaviors.componentTrailMap.getTrailElement(instanceId);
      var url = [location.protocol, '//', location.host, location.pathname].join('');
      var urlParams = [];

      // Add filter category data.
      var filterCategoryData = getNestedValue($('.form-item-filter', $trailElement).data(), ['pOptions', 'value', 'category'], []);
      if (filterCategoryData.length > 0) {
        urlParams.push('category=' + filterCategoryData.join(','));
      }
      var filterRegionData = selectedRegion;
      var filterCityData = selectedCity;

      if (selectedRegion !== null && typeof selectedRegion !== 'undefined') {
        urlParams.push('selected-region=' + filterRegionData);
        $('.form-item-going').find('a[data-clear="where"]').addClass('active');
      }

      if (selectedCity !== null && typeof selectedCity !== 'undefined') {
        urlParams.push('selected-city=' + filterCityData);
        $('.form-item-going').find('a[data-clear="where"]').addClass('active');
      }

      // Append url params if any are set.
      if (urlParams.length > 0) {
        url += '?' + urlParams.join('&');
      }

      if (history.replaceState) {
        window.history.replaceState({}, '', url);
      }

    },

    /**
     * Get City name from Google Reverse Geolocation API.
     *
     * @param {null|string} selectedCity
     *   The selected city.
     * @return {null|string}
     *   The city name.
     */
    getCityName: function (selectedCity) {
      var cityName;
      if (selectedCity !== null) {
        var lat = parseFloat(selectedCity.split(', ')[0]);
        var lng = parseFloat(selectedCity.split(', ')[1]);
        var keyGoogleMaps = drupalSettings.tnv_google_maps.settings.api_key;
        $.ajax({
          url: 'https://maps.googleapis.com/maps/api/geocode/json?latlng=' + lat + ', ' + lng + '&key=' + keyGoogleMaps,
          success: function (result) {
            var address_components = result.results['0'].address_components;
            var address_types = [];
            for (var i = 0; i < address_components.length; i++) {
              address_types[i] = address_components[i].types;
              if (address_components[i].types.includes('locality')) {
                cityName = address_components[i].long_name;
              }
            }
            $('[data-filter-controller~="location"] a.pselect-display-value').html(cityName);
          }
        });
      }
      return cityName;
    },

    /**
     * Initialize Mobile Filters
     *
     * @param {jQuery} $trailElement
     *   The Trail jQuery element.
     *
     */
    initializeMobileFilters: function ($trailElement) {
      var trailFilter = $trailElement.find('.pselect-wrapper[data-filter-name="trail"]');
      var locationTypeFilter = $trailElement.find('.poptions__display-value[data-filter-name="location-type"]');
      var locationFilter = $trailElement.find('.pselect-wrapper[data-filter-name="location"]');

      if (window.matchMedia('(max-width: 768px)').matches) {
        trailFilter.addClass('mobile-filter-trigger');
        locationTypeFilter.addClass('mobile-filter-trigger');
        locationFilter.addClass('mobile-filter-trigger');
      }
      else {
        $trailElement.find('.modal').removeClass('js-active');
        $('body').removeClass('modal-active');
        trailFilter.removeClass('mobile-filter-trigger');
        locationTypeFilter.removeClass('mobile-filter-trigger');
        locationFilter.removeClass('mobile-filter-trigger');
      }
    },

    /**
     * Mobile Filter Click Events
     *
     * @param {jQuery} $trailElement
     *   The Trail jQuery element.
     *
     */
    mobileFilterClickEvents: function ($trailElement) {
      var trailMobileFilterTrigger = $trailElement.find('.mobile-filter-trigger[data-filter-name="trail"]');
      var mobileTrailFilterModal = $trailElement.find('.modal[data-filter-name="trail"]');

      var locationTypeMobileFilterTrigger = $trailElement.find('.mobile-filter-trigger[data-filter-name="location-type"]');
      var mobileLocationTypeFilterModal = $trailElement.find('.modal[data-filter-name="location-type"]');
      var intiialFilterCategories = [];

      var locationMobileFilterTrigger = $trailElement.find('.mobile-filter-trigger[data-filter-name="location"]');
      var mobileLocationFilterModal = $trailElement.find('.modal[data-filter-name="location"]');

      if (window.matchMedia('(max-width: 768px)').matches) {
        $(trailMobileFilterTrigger).click(function () {
          if ($(trailMobileFilterTrigger).hasClass('mobile-filter-trigger')) {
            // Display Mobile Filter Modal
            $(mobileTrailFilterModal).addClass('js-active');
            $('body').addClass('modal-active');
          }
        });

        $(mobileTrailFilterModal).find('.close').click(function () {
          // Hide Mobile Filter Modal
          $(mobileTrailFilterModal).removeClass('js-active');
          $('body').removeClass('modal-active');
        });

        $(locationTypeMobileFilterTrigger).click(function () {
          if ($(locationTypeMobileFilterTrigger).hasClass('mobile-filter-trigger')) {
            // Display Mobile Filter Modal
            $(mobileLocationTypeFilterModal).addClass('js-active');
            $('body').addClass('modal-active');
          }
        });

        $(mobileLocationTypeFilterModal).find('.close').click(function () {
          // Hide Mobile Filter Modal
          $(mobileLocationTypeFilterModal).removeClass('js-active');
          $('body').removeClass('modal-active');
        });

        $(mobileLocationTypeFilterModal).find('.tmp-location-type-filter__apply-filter-btn').click(function () {
          // Hide Mobile Filter Modal
          $(mobileLocationTypeFilterModal).removeClass('js-active');
          $('body').removeClass('modal-active');
        });

        $(locationMobileFilterTrigger).click(function () {
          if ($(locationMobileFilterTrigger).hasClass('mobile-filter-trigger')) {
            // Display Mobile Filter Modal
            $(mobileLocationFilterModal).addClass('js-active');
            $('body').addClass('modal-active');
          }
        });

        $(mobileLocationFilterModal).find('.close').click(function () {
          // Hide Mobile Filter Modal
          $(mobileLocationFilterModal).removeClass('js-active');
          $('body').removeClass('modal-active');
        });

        $(mobileLocationFilterModal).find('.tmp-mobile-location-filter__apply-filter-btn').click(function () {
          // Hide Mobile Filter Modal
          $(mobileLocationFilterModal).removeClass('js-active');
          $('body').removeClass('modal-active');
        });

        // Initialize Location Type Mobile Filter
        if ($.urlParam('category') !== null) {
          intiialFilterCategories = $.urlParam('category').split(',');
          $(intiialFilterCategories).each(function (index, value) {
            $(mobileLocationTypeFilterModal).find('.form-checkbox[value=' + value + ']').prop('checked', 'true');
          });
        }

        // Click events for Mobile Location Type Filter
        $(mobileLocationTypeFilterModal).find('.form-checkbox').click(function () {
          var selectedLocationType = ($(this).val());
          var filterPlugin = $('.form-item-filter', $trailElement).data('pOptions');
          if ($(this).is(':checked')) {
            filterPlugin.select($(locationTypeMobileFilterTrigger).next().find('input[type=checkbox][value=' + selectedLocationType + ']'));
          }
          else {
            filterPlugin.unselect($(locationTypeMobileFilterTrigger).next().find('input[type=checkbox][value=' + selectedLocationType + ']'));
          }
        });

        // Mobile Location Filter
        $('input[data-drupal-selector=edit-mobile-search-by-city]').on('autocompleteclose', function (e) {
          var str = e.target.value;
          var textToDisplay = str.split(') ').pop();
          if (textToDisplay) {
            $(this).val(textToDisplay);
            $('input[data-drupal-selector=edit-going-city-search]', $trailElement).val(textToDisplay).autocomplete('search');
            $('input[data-drupal-selector=edit-going-city-search]', $trailElement).on('autocompleteopen', function (event, ui) {
              $(this).data('ui-autocomplete').menu.element.children().first().click();
              $(this).unbind('autocompleteopen');
            });
          }
        });

        $(mobileLocationFilterModal).find('.tmp-filter-options-wrapper__list-item').click(function () {
          var selectedLocation = $(this).data('area');
          $trailElement.find('.form-item-going').find('.pselect-item[data-filter-value=' + selectedLocation + ']').trigger('click');
        });

      }
    },

    /**
     * Update the main trail filter based on the value in Drupal Settings
     *
     * @param {string} trail
     * The Trail Name.
     */
    updateMainTrailFilter: function (trail) {
      // Update dropdown with Drupal Settings Value if they match the url param
      if (typeof drupalSettings.trailName !== 'undefined') {
        var trailName = drupalSettings.trailName;
        if (trailName.indexOf('?') > -1) {
          trailName = trailName.substring(0, trailName.indexOf('?'));
        }
        if (trailName === 'All') {
          trailName = 'All Trails';
        }
        // With addition of area regions, only set trail select value if trail or all trails.
        if (trailName.includes('Trail')) {
          $('[data-filter-controller~="trail"] a.pselect-display-value').html(trailName);
        }
        else if (trailName.includes('Area')) {
          var selectedRegion = $('[data-filter-controller~="location"] a.pselect-item:contains(' + trailName + ')');
          $('[data-filter-controller~="location"] a.pselect-display-value').html(selectedRegion.html());
        }
        delete drupalSettings.trailName;
      }
      if ($.urlParam('selected-city') !== null) {
        Drupal.behaviors.componentTrailMap.getCityName($.urlParam('selected-city'));
      }
    },

    /**
     * Reset map bounds based on passed-in geolocations.
     *
     * @param {string} instanceId
     *   The Trail instance ID.
     * @param {null|Object} geolocationGoing
     *   An object with lat and lng properties set. Null otherwise.
     * @param {null|Object} geolocationComing
     *   An object with lat and lng properties set. Null otherwise.
     * @param {null|Array} latLngArray
     *   An array with lat and lng properties set. Null otherwise.
     */
    positionMap: function (instanceId, geolocationGoing, geolocationComing, latLngArray) {
      // Get trail map.
      var trailMap = Drupal.behaviors.componentTrailMap.getTrailMap(instanceId);

      // Initialize geolocation min and max values from sw and ne corners.
      var latMax = Drupal.behaviors.componentTrailMap.trailGeolocations.directions.ne.lat;
      var latMin = Drupal.behaviors.componentTrailMap.trailGeolocations.directions.sw.lat;
      var lngMax = Drupal.behaviors.componentTrailMap.trailGeolocations.directions.ne.lng;
      var lngMin = Drupal.behaviors.componentTrailMap.trailGeolocations.directions.sw.lng;
      var latPadding = 0;
      var lngPadding = 0;

      // If on mobile, position center of map based on coming, otherwise going.
      if ($('body').width() < 1024) {
        if (geolocationComing !== null) {
          // Set center of the map to coming.
          latMax = geolocationComing.lat;
          latMin = geolocationComing.lat;
          lngMax = geolocationComing.lng;
          lngMin = geolocationComing.lng;

          // Disable going parameter.
          geolocationGoing = null;

          // Set padding.
          latPadding = 0.35;
          lngPadding = 0.35;
        }
      }

      // If going is set, it is now the primary bounds object.
      if (geolocationGoing !== null) {
        // Reset geolocation min and max values to 'going' values.
        latMax = geolocationGoing.lat;
        latMin = geolocationGoing.lat;
        lngMax = geolocationGoing.lng;
        lngMin = geolocationGoing.lng;

        // Set padding (to center if only 'going' point is provided).
        latPadding = 0.35;
        lngPadding = 0.35;

        // If 'coming' is provided, modify relevant min/max values.
        if (geolocationComing !== null) {
          // Set padding to more-properly size padding around bounds.
          latPadding = 0.15;
          lngPadding = 0.10;

          // Reset either min or max lat.
          if (geolocationComing.lat < geolocationGoing.lat) {
            latMin = geolocationComing.lat;
          }
          else {
            latMax = geolocationComing.lat;
          }

          // Reset either min or max lng.
          if (geolocationComing.lng < geolocationGoing.lng) {
            lngMin = geolocationComing.lng;
          }
          else {
            lngMax = geolocationComing.lng;
          }
        }
      }

      // Increase values to give some padding around bounds.
      latMax += latPadding;
      latMin -= latPadding;
      lngMax += lngPadding;
      lngMin -= lngPadding;

      // Create bounds object.
      var bounds = new google.maps.LatLngBounds();

      // Auto center by marker points if available.
      if (geolocationGoing === null && latLngArray !== null) {
        for (var i = 0; i < latLngArray.length; i++) {
          bounds.extend(latLngArray[i]);
        }
      }
      else {
        // Add NW latlng bounds.
        bounds.extend(new google.maps.LatLng(latMax, lngMin));
        // Add SE latlng bounds.
        bounds.extend(new google.maps.LatLng(latMin, lngMax));
      }

      // Set bounds on map.
      trailMap.fitBounds(bounds);
    },

    /**
     * Gets a trail jQuery element by instance ID.
     *
     * @param {string} instanceId
     *   The Trail instance ID.
     *
     * @return {*|HTMLElement}
     *   The trail element.
     */
    getTrailElement: function (instanceId) {
      return $('.component-trail[data-instance-id=' + instanceId + ']');
    },

    /**
     * Gets a trail ID by trail instance ID.
     *
     * @param {string} instanceId
     *   The Trail instance ID.
     *
     * @return {number}
     *   The trail ID.
     */
    getTrailId: function (instanceId) {
      return Drupal.behaviors.componentTrailMap.getTrailElement(instanceId).data('trail-id');
    },

    /**
     * Gets a trail instance's map object.
     *
     * @param {string} instanceId
     *   The Trail instance ID.
     *
     * @return {*}
     *   The google map object.
     */
    getTrailMap: function (instanceId) {
      return Drupal.behaviors.componentTrailMap.trailMaps[instanceId];
    },

    /**
     * Gets a trail location marker for a specific trail instance.
     *
     * @param {string} instanceId
     *   The Trail instance ID.
     * @param {number} locationId
     *   The Trail location ID.
     *
     * @return {*}
     *   The google map marker object.
     */
    getTrailMarker: function (instanceId, locationId) {
      return Drupal.behaviors.componentTrailMap.trailMapMarkers[instanceId][locationId];
    },

    /**
     * Gets a trail marker cluster for a specific trail instance.
     *
     * @param {string} instanceId
     *   The Trail instance ID.
     *
     * @return {MarkerClusterer}
     *   The google map marker cluster object.
     */
    getTrailMarkerCluster: function (instanceId) {
      return Drupal.behaviors.componentTrailMap.trailMapMarkerClusters[instanceId];
    },

    /**
     * Gets a trail marker spidefier for a specific trail instance.
     *
     * @param {string} instanceId
     *   The Trail instance ID.
     *
     * @return {MarkerClusterer}
     *   The google map marker spidefier object.
     */
    getTrailMarkerSpiderfier: function (instanceId) {
      return Drupal.behaviors.componentTrailMap.trailMapMarkerSpiderfiers[instanceId];
    },

    /**
     * Gets a trail location's data object.
     *
     * @param {string} trailId
     *   The Trail ID.
     * @param {number} locationId
     *   The Trail location ID.
     *
     * @return {Object}
     *   A trail location's javascript object.
     */
    getTrailLocation: function (trailId, locationId) {
      return Drupal.behaviors.componentTrailMap.trailLocations[trailId][locationId];
    },

    /**
     * Gets a list of locations for a trail.
     *
     * @param {string} trailId
     *   The Trail ID.
     *
     * @return {Object}
     *   An array of trail location objects, keyed by location ID.
     */
    getTrailLocations: function (trailId) {
      return Drupal.behaviors.componentTrailMap.trailLocations[trailId];
    }
  };

})(jQuery, Drupal, drupalSettings, once); // eslint-disable-line no-undef
